import React from "react";
import { Link } from "react-router-dom";
import { Logo, GradientBar, Button } from "@/components/design-system";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#E8F1FF] flex flex-col">
      <header className="bg-white border-b border-[#0B1F3A]/10">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <Link to="/"><Logo variant="light" height={54} /></Link>
        </div>
        <GradientBar />
      </header>
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-lg text-center">
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#2D7FF9]">404</p>
          <h1 className="font-[Montserrat] font-extrabold text-5xl mt-2 text-[#0B1F3A] tracking-tighter">Off the launch path.</h1>
          <p className="mt-4 text-[#0B1F3A]/75">The page you were looking for doesn't exist yet — it might arrive in a later build cycle.</p>
          <div className="mt-6 flex gap-3 justify-center">
            <Link to="/"><Button variant="primary">Back to home</Button></Link>
            <Link to="/app"><Button variant="secondary">Open the app</Button></Link>
          </div>
        </div>
      </main>
    </div>
  );
}
